const HEADER_HEIGHT = 64;
const OFFSET = 16;
export const DEFAULT_OPTIONS: IntersectionObserverInit = {
  threshold: 0,
  rootMargin: `-${HEADER_HEIGHT + OFFSET}px`,
  root: null,
};
